var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
                component: 'label',
            },
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextSmall), { display: 'inline', position: 'relative', color: designTokens.color.shade.black.value, transform: 'none', '&.Mui-focused': {
                        color: designTokens.color.shade.black.value,
                    }, '&.Mui-disabled': {
                        color: designTokens.color.shade.black.value,
                    }, '&.Mui-error': {
                        color: designTokens.color.shade.black.value,
                    } }),
                asterisk: {
                    color: theme.palette.error.main,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=inputLabelTheme.js.map